import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent} from 'react'
import React from 'react'
import type {RootLoaderResponse, SortingOption} from '~/types'
import {getDomainConfig} from '~/domains'
import ProductsHeaderNewLayout from './products-header-new-layout'
import ProductsAboveTheListHeader from './products-above-the-list-header'
import MagaListHeader from './maga-list-header'

interface ListHeaderProps {
  sortBy: SortingOption | null
  setSortBy: React.Dispatch<React.SetStateAction<SortingOption | null>>
}
const ListHeader: FunctionComponent<ListHeaderProps> = ({setSortBy, sortBy}) => {
  const {isUSLocale, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {domainType} = getDomainConfig(domain, locale)

  switch (true) {
    case domainType === 'maga':
      return <MagaListHeader />
    case isUSLocale:
      return <ProductsHeaderNewLayout sortBy={sortBy} setSortBy={setSortBy} />
    default:
      return <ProductsAboveTheListHeader />
  }
}

export default ListHeader
